export const ALIPAY = 'alipay';
export const WE_CHAT_PAY = 'wechat_pay';